import {
  Box, Table, TableContainer, TablePagination
} from '@mui/material';
import { ChangeEvent, FC, useCallback, createContext } from 'react';
import { UseSelectableItemsIdType } from 'src/utils/hooks/useSelectableItems';

interface WbTableProps {
  setSelectedItem?: (id: UseSelectableItemsIdType, checked: boolean) => void;
  selectedIds?: UseSelectableItemsIdType[];
  hasSelectedItems?: boolean;
  allItemsSelected?: boolean;
  selectAllItems?: (selected: boolean) => void;
  rowsPerPage?: number;
  page: number;
  onPageChange: (newPage: number) => void;
  onRowsPerPageChange: (value: number) => void;
  count: number;
  allowSelect?: boolean;
}

export const WbTableContext = createContext<WbTableProps>(null)

export const WbTable: FC<WbTableProps> = ({
  children,
  setSelectedItem,
  selectedIds,
  hasSelectedItems,
  allItemsSelected,
  selectAllItems, 
  rowsPerPage,
  page,
  onPageChange,
  onRowsPerPageChange,
  count,
  allowSelect = true
}) => {
  const handleRowsPerPageChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    onRowsPerPageChange(parseInt(e.target.value))
  }, [onRowsPerPageChange])

  const handlePageChange = useCallback((_, newPage: number) => {
    // force pagaination to be 1 based
    onPageChange(newPage + 1)
  }, [onPageChange])

  const contextValue = {
    setSelectedItem,
    selectedIds,
    hasSelectedItems,
    allItemsSelected,
    selectAllItems, 
    rowsPerPage,
    page,
    onPageChange,
    onRowsPerPageChange,
    count,
    allowSelect
  }

  return (
    <WbTableContext.Provider value={contextValue}>
      <TableContainer>
        <Table>{children}</Table>
        <Box p={2}>
          <TablePagination
            component="div"
            count={count}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            page={page - 1}
            rowsPerPage={rowsPerPage || 20}
            rowsPerPageOptions={[]} 
            showFirstButton
            showLastButton
          />
        </Box>
      </TableContainer>
    </WbTableContext.Provider>
  );
};

